<template>
  <div>
    <single-select :value.sync="compValue" :value-property="'value'" :options="options" :readonly="readonly">
    </single-select>
  </div>
</template>

<script>
export default {
  name: "CompanyBranchDropdown",
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'single-select': () => import("@/components_rms/base/SingleSelect.vue"),
  },
  data() {
    return {
      options: [{ value: null, text: this.$t("geral.loadingData") }],
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    compValue: {
      get: function () {
        if (this.options) {
          return this.value;
        }
        return null;
      },
      set: function (newValue) {
        this.$emit("update:value", parseInt(newValue));
      },
    },
    getLoadDataUrl() {
      return `/empresa/all`;
    },
  },
  methods: {
    loadData() {
      let apiParam = {
        currentPage: 1,
        perPage: 9999,
      };

      this.$api
        .post(this.getLoadDataUrl, apiParam)
        .then((response) => {
          let companies = response.data.items;
          let companiesOptions = [];
          for (let company of companies) {
            companiesOptions.push({
              value: company.id,
              text: company.branchName,
            });
          }
          this.options = companiesOptions;
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
